import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import { Col, Form, Modal, ModalBody } from "react-bootstrap";
import FormGroup from "controls/formGroup";
import FormLabel from "controls/formLabel";
import InternalReportDetailViewModel from "viewModels/timeCharges/reporting/internalReports/internalReportDetailViewModel";
import LoaderOverlay from "@edaz/edazkit/LoaderOverlay";
import { formatDateTime } from "utils/localizations";
import FakeInput from "@edaz/edazkit/controls/FakeInput";
import { busyIdentificator } from "utils/busyWatcher";
import Button from "@edaz/edazkit/Button/index";
import { IconType } from "@edaz/edazkit/Icon";

const InternalReportDetailView: ViewComponent<InternalReportDetailViewModel> = observer(({ vm }) => {
  const isBusy = vm.busyWatcher.checkBusy(busyIdentificator([vm.item]));

  return (
    <Modal scrollable show={true} onHide={vm.requestClose} centered dialogClassName="modal-90w">
      <Modal.Header closeButton={true}>
        <Modal.Title style={{ display: "flex", width: "100%", justifyContent: "space-between" }}>
          <span>{vm.item?.reportName}</span>
          <Button
            variant="success"
            size="sm"
            className="rounded ml-4"
            onClick={() => vm.onDownload(vm.item)}
            disabled={isBusy}
            iconLeft={isBusy ? IconType.Spinner : IconType.Download}>
            {vm.translate("downloadFile")}
          </Button>
        </Modal.Title>
      </Modal.Header>
      <ModalBody>
        <LoaderOverlay loading={vm.busyWatcher.isBusy}>
          <Form.Row className="mb-4 p-4 bg-light rounded">
            <FormGroup as={Col} md="3">
              <FormLabel>{vm.translate("amountOfRecords")}</FormLabel>
              <FakeInput valueFormatter={() => vm.rows} />
            </FormGroup>
          </Form.Row>
          <table className="table">
            <thead>
              <tr>
                <th>{vm.translate("createdAt")}</th>
                <th>{vm.translate("createdBy")}</th>
                <th>{vm.translate("action")}</th>
              </tr>
            </thead>
            <tbody>
              {vm.item?.downloads
                .sort((a, b) => b.createdAt.getTime() - a.createdAt.getTime())
                .map(download => (
                  <tr key={`${download.createdBy}-${download.createdAt.toISOString()}`}>
                    <td>{formatDateTime(download.createdAt)}</td>
                    <td>{download.createdBy}</td>
                    <td>{vm.translate("downloadedReport")}</td>
                  </tr>
                ))}
              {vm.item && (
                <tr>
                  <td>{formatDateTime(vm.item.processedAt)}</td>
                  <td>{vm.item.createdBy}</td>
                  <td>{vm.translate("generatedReport")}</td>
                </tr>
              )}
            </tbody>
          </table>
          {!vm.item && (
            <div className="py-3 px-4 mb-4 mt-n2 bg-white border-bottom text-muted">
              {vm.translateGeneral(vm.busyWatcher.isBusy ? "loading" : "empty")}
            </div>
          )}
        </LoaderOverlay>
      </ModalBody>
    </Modal>
  );
});

registerView(InternalReportDetailView, InternalReportDetailViewModel);
